import React from 'react';

import type { IconProps } from '../../icon-types';
import { IconBase } from '../../IconBase';

export const ArrowForwardIcon = React.forwardRef<SVGSVGElement, IconProps>(function ArrowForwardIcon(props, ref) {
    return (
        <IconBase ref={ref} viewBox="0 0 24 24" {...props}>
            <path fill="currentColor" d="m12 4-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"/>
        </IconBase>
    );
});
